(function () {
  'use strict';

  if (window.__fabPosthogIdentity) return;

  function readFabAnonId() {
    try {
      return window.__fab_anon_id || window.localStorage.getItem('fab_anon_id') || null;
    } catch (e) {
      return window.__fab_anon_id || null;
    }
  }

  function normalizeEmail(email) {
    if (!email) return null;
    var normalized = String(email).trim().toLowerCase();
    return normalized && normalized.indexOf('@') > -1 ? normalized : null;
  }

  function registerFabAnonSuperProp(ph) {
    ph = ph || window.posthog;
    var fabId = readFabAnonId();
    if (!fabId || !ph || typeof ph.register !== 'function') return;
    try {
      ph.register({ fab_anon_id: fabId });
    } catch (e) {}
  }

  function identifyTrustedEmail(email, personProps) {
    var normalized = normalizeEmail(email);
    if (!normalized) return false;

    var ph = window.posthog;
    if (!ph || typeof ph.identify !== 'function') return false;

    try {
      var current = typeof ph.get_distinct_id === 'function' ? ph.get_distinct_id() : null;
      var isEmailId = typeof current === 'string' && current.indexOf('@') !== -1;
      if (isEmailId && current !== normalized) {
        ph.reset();
        registerFabAnonSuperProp(ph);
      }

      var props = Object.assign({ email: normalized, $email: normalized }, personProps || {});
      var fabId = readFabAnonId();
      if (fabId) props.fab_anon_id = fabId;

      ph.identify(normalized, props);
      registerFabAnonSuperProp(ph);
      return true;
    } catch (e) {
      return false;
    }
  }

  function resetOnLogout() {
    var ph = window.posthog;
    if (!ph || typeof ph.reset !== 'function') return;
    try {
      ph.reset();
      registerFabAnonSuperProp(ph);
    } catch (e) {}
  }

  function bindLogoutLinks() {
    document.addEventListener(
      'click',
      function (event) {
        try {
          var target = event.target;
          var link = target && target.closest ? target.closest('a[href*="/account/logout"]') : null;
          if (!link) return;
          resetOnLogout();
        } catch (e) {}
      },
      true
    );
  }

  window.__fabPosthogIdentity = {
    readFabAnonId: readFabAnonId,
    normalizeEmail: normalizeEmail,
    registerFabAnonSuperProp: registerFabAnonSuperProp,
    identifyTrustedEmail: identifyTrustedEmail,
    resetOnLogout: resetOnLogout
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLogoutLinks);
  } else {
    bindLogoutLinks();
  }
})();
